import { sweepColors } from './sweepColors';
export var objectTypeColors = {
    Lead: sweepColors.sun[300],
    Account: sweepColors.seafoam[300],
    Opportunity: sweepColors.lilac[300],
    Contact: sweepColors.sky[300],
    Case: sweepColors.gum[300],
};
